// extracted by mini-css-extract-plugin
module.exports = {"base":"serial-stories-tab-m__base__1gwrQ"};